<app-dataspace-report-workspace-layout
  [title]="'Meine Tagesberichte'"
  [subtitle]="''"
  [stats]="stats">

  <div workspace-sidebar class="dataspace-pane">
    <mat-card class="dataspace-pane__toolbar-card">
      <div class="dataspace-pane__toolbar">
        <button mat-raised-button color="primary" class="dataspace-toolbar-button" (click)="openNewReport()">
          <mat-icon>add</mat-icon>
          Neuer Tagesbericht
        </button>
        <div class="dataspace-toolbar-filters">
          <mat-form-field appearance="outline" class="dataspace-filter-field">
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="statusFilter">
              <mat-option value="">Alle</mat-option>
              <mat-option value="ENTWURF">Entwurf</mat-option>
              <mat-option value="FINALISIERT">Finalisiert</mat-option>
              <mat-option value="ARCHIVIERT">Archiviert</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </mat-card>

    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

    <div class="dataspace-list" *ngIf="!loading && filteredReports.length">
      <button
        type="button"
        class="dataspace-list-item"
        *ngFor="let report of filteredReports; trackBy: trackByReportId"
        [class]="getStatusTone(report.status)"
        [class.is-selected]="selectedReport?.id === report.id"
        (click)="selectReport(report)">
        <div class="dataspace-list-item__meta">
          <span>{{ report.reportDate ? (report.reportDate | date:'dd.MM.yyyy') : 'Ohne Datum' }}</span>
        </div>
        <strong>{{ report.projectLabel }}</strong>
        <span>{{ report.subtitle }}</span>
        <div class="dataspace-list-item__footer">
          <app-dataspace-report-status-badge [status]="report.status"></app-dataspace-report-status-badge>
          <small>{{ formatTimestamp(report.updatedAt) }}</small>
        </div>
      </button>
    </div>

    <mat-card class="dataspace-empty-state" *ngIf="!loading && !filteredReports.length">
      <mat-icon>assignment</mat-icon>
      <strong>Noch keine NU Tagesberichte</strong>
      <span>Erstellen Sie den ersten Tagesbericht. Die Freigabe erfolgt künftig über den Connector.</span>
    </mat-card>
  </div>

  <div workspace-detail class="dataspace-detail" *ngIf="selectedReport; else nuEmptySelection">
    <mat-card class="dataspace-detail__hero">
      <div>
        <div class="dataspace-detail__eyebrow">Tagesbericht</div>
        <h3>{{ selectedReport.projectLabel }}</h3>
        <p>{{ selectedReport.subtitle }}</p>
      </div>
      <app-dataspace-report-status-badge [status]="selectedReport.status"></app-dataspace-report-status-badge>
    </mat-card>

    <div class="dataspace-detail__grid">
      <mat-card class="dataspace-detail__card dataspace-detail__card--full">
        <div class="dataspace-card__header">
          <div>
            <h4>Bericht-Details</h4>
            <p>Verwaltung und Bearbeitung des Tagesberichts.</p>
          </div>
        </div>

        <div class="dataspace-transfer-grid">
          <div>
            <span class="label">Organisation</span>
            <strong>{{ organisationName || 'Nicht gesetzt' }}</strong>
          </div>
          <div>
            <span class="label">Datum</span>
            <strong>{{ selectedReport.reportDate ? (selectedReport.reportDate | date:'dd.MM.yyyy') : 'Ohne Datum' }}</strong>
          </div>
          <div>
            <span class="label">Status</span>
            <strong>{{ selectedReport.status }}</strong>
          </div>
          <div>
            <span class="label">Aktualisiert</span>
            <strong>{{ formatTimestamp(selectedReport.updatedAt) }}</strong>
          </div>
        </div>

        <div class="dataspace-action-row">
          <button
            mat-stroked-button
            color="primary"
            [disabled]="selectedReport.status === 'ARCHIVIERT'"
            (click)="openSelectedReport()">
            Bericht bearbeiten
          </button>
          <button mat-stroked-button (click)="openSelectedReportPreview()" [disabled]="!selectedReport.draft?.fieldValues">
            Vorschau ansehen
          </button>
          <button
            mat-raised-button
            color="primary"
            *ngIf="selectedReport.status === 'ENTWURF'"
            [disabled]="busy || !selectedReport.draftId"
            (click)="finaliseSelectedReport()">
            Finalisieren
          </button>
          <button
            mat-stroked-button
            *ngIf="selectedReport.status === 'FINALISIERT' || selectedReport.status === 'ENTWURF'"
            [disabled]="busy || !selectedReport.draftId"
            (click)="archiveSelectedReport()">
            <mat-icon>archive</mat-icon>
            Archivieren
          </button>
          <button
            mat-stroked-button
            color="warn"
            [disabled]="busy"
            (click)="deleteSelectedReport()">
            Bericht löschen
          </button>
        </div>
      </mat-card>

      <mat-card class="dataspace-detail__card dataspace-detail__card--internal">
        <div class="dataspace-card__header">
          <div>
            <h4>Vorschau der Inhalte</h4>
            <p>Diese Felder wurden im Bericht erfasst.</p>
          </div>
        </div>

        <div class="dataspace-section-grid" *ngIf="selectedReport.sharedSections.length || selectedReport.internalSections.length; else noSections">
          <div class="dataspace-section" *ngFor="let section of selectedReport.sharedSections">
            <div class="dataspace-section__title">{{ section.title }}</div>
            <strong class="dataspace-section__summary-title">{{ section.summaryTitle }}</strong>
            <p *ngFor="let line of section.summaryLines">{{ line }}</p>
          </div>
          <div class="dataspace-section" *ngFor="let section of selectedReport.internalSections">
            <div class="dataspace-section__title">{{ section.title }} (Intern)</div>
            <strong class="dataspace-section__summary-title">{{ section.summaryTitle }}</strong>
            <p *ngFor="let line of section.summaryLines">{{ line }}</p>
          </div>
        </div>

        <ng-template #noSections>
          <div class="dataspace-empty-block">
            Für diesen Bericht sind noch keine Inhalte hinterlegt.
          </div>
        </ng-template>
      </mat-card>

      <mat-card class="dataspace-detail__card dataspace-detail__card--activity">
        <div class="dataspace-card__header">
          <div>
            <h4>Aktivität</h4>
            <p>Erstellung und Statusänderungen des Berichts.</p>
          </div>
        </div>

        <app-activity-timeline
          [usageEvents]="[]"
          [auditEntries]="selectedDetail?.auditEntries || []">
        </app-activity-timeline>
      </mat-card>
    </div>

    <mat-card class="dataspace-error-card" *ngIf="error">
      <mat-icon>error</mat-icon>
      <span>{{ error }}</span>
    </mat-card>
  </div>
</app-dataspace-report-workspace-layout>

<ng-template #nuEmptySelection>
  <mat-card class="dataspace-empty-state">
    <mat-icon>fact_check</mat-icon>
    <strong>Kein Bericht ausgewählt</strong>
    <span>Wählen Sie links einen Tagesbericht aus, um Details zu sehen.</span>
  </mat-card>
</ng-template>
